import { render } from "./AppProductList.vue?vue&type=template&id=14669752"
import script from "./AppProductList.vue?vue&type=script&lang=js"
export * from "./AppProductList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__